import React, { useEffect } from "react";
import "./HeroBanner.css";
import Header from "../Header/Header";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { InlineWidget } from "react-calendly";

const HeroBanner = ({
  Heading,
  subHeading,
  spanHeading="",
  Paragraph,
  btnText,
  bgImg,
  bgVideo=false,
  btn=false,
  socialLinks=false,
  serviceForm=false,
  ConsultationBtn=false,
  textCenter=false,
  btnRefTel=false,
  textWidthFull=false,
  showPartners=false,
  smallHeading=false
}) => {
  const navigate = useNavigate()
   const [name, setName] = useState("");
   const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
   const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [captchaToken, setCaptchaToken] = useState(null);

    const handleCaptchaChange = (token) => {
      setCaptchaToken(token)
    };

  
    const formSubmitHandler = (e) => {
      e.preventDefault();
      if(!captchaToken)
      {
        alert("please check reCAPTCHA")
        return
      }
      setLoading(true);
      axios
        .post("/send-quote", {
          email: email,
          name:name,
          message:message,
          phone:phone,
          formType: "Contact Form",
        })
        .then((response) => {
          if (response.data.msg === "success") {
            setError(false);
            setSuccess("Request for Contact sended Successfully!");
            setLoading(false);
            setEmail("");
            
          } else if (response.data.msg === "fail") {
            setSuccess(false);
            setError("Failed to send, try again by reloading the page.");
            setLoading(false);
            setEmail("");
          }
        });
    };
  
   
    const handlePhoneChange = (e) => {
     const numericValue = e.target.value.replace(/\D/g, ''); 
      const maxLength = 20; 
      if (numericValue.length <= maxLength) {
        setPhone(numericValue);
      }
    };

  return (
    <div
      className={`common_hero_section ${bgVideo && "bg-video"} d-flex flex-column`}
      style={{ backgroundImage: `url(${bgImg})` }}
    >
       { bgVideo && <video autoPlay loop muted>
        <source src="./images/backgroundVideo.webm" type="video/mp4" />
      </video>}

      <div>
        <Header />
      </div>

      <div className="container my-auto d-flex align-items-center py-5" style={bgVideo ? {height:"75%"}:{}}>
        <div className={`row gy-2 ${serviceForm && "align-items-center"}`}>
          <div
            className={
              serviceForm
                ? "col-md-6 "
                : `col-12 hero_content_wrapper px-3 ${textCenter && "w-100"} ${textWidthFull && "w-100"}`
            }
          >
            <div className={`hero-text-content  ${textCenter && "text-center w-100"}`}>
            {subHeading && <h5 className="sub-heading w-100">{subHeading}</h5>}
            <h1  className={`hero-section-heading  ${textCenter && "text-center"} ${smallHeading && "smallHeadingFont"}`} style={serviceForm ? {fontSize:"2.6rem"}:{}}>
              {Heading}
              <span className="heading-color-change">{spanHeading}</span>
            </h1>
            {Paragraph && <p className={`body-paragraph ${textCenter && "text-center mx-auto"} `}>{Paragraph}</p>}
            {btn && 
            <button className="hero-btn blue-btn" onClick={()=>{if(btnRefTel){window.open("tel:+14169042013")}else{navigate("/contact")}}}>{btnText}</button>}
            {ConsultationBtn && 
              <div className='btn-container d-flex flex-lg-row flex-column align-items-lg-center align-items-start justify-content-lg-start justify-content-center gap-4 mt-5 '>
                  <button className='blue-btn ' onClick={()=>{window.open("https://calendly.com/chandrancpa","blank")}}>Schedule a Consultation </button>
                  <button className='hero-btn' onClick={()=>{window.open("tel:+14169042013")}}>+14169042013</button>
              </div>
            }
            {socialLinks && (
              <div className="social-links py-2">
                <div className="first-row d-flex gap-3">
                  <div className="link-container d-flex align-items-center gap-1">
                    <img  alt="phone" loading="lazy" src="/images/icons/social-1.png" />
                    <p className="m-0" style={{cursor:'pointer'}} onClick={()=>{window.open("tel:+14169042013")}}>+14169042013</p>
                  </div>
                  {/* <div className="link-container d-flex align-items-center gap-1">
                    <img loading="lazy" src="/images/icons/social-2.png" />
                    <p className="m-0">416-904-2013</p>
                  </div> */}
                  
                </div>
                <div className="link-container d-flex align-items-center gap-1">
                  <img alt="email" loading="lazy" src="/images/icons/social-3.png" />
                  <p className="m-0" style={{cursor:'pointer'}} onClick={()=>{window.open("mailto:info@lotusaccounting.ca")}}>info@lotusaccounting.ca</p>
                </div>
                <div className="link-container d-flex align-items-center gap-1">
                  <img alt="address" loading="lazy" src="/images/icons/social-4.png" />
                  <p className="m-0">Suite 304-305 Milner Ave. Toronto, ON M1B 3V4</p>
                </div>
                <div className="link-container d-flex align-items-center gap-1">
                  <img alt="working hours" loading="lazy" src="/images/icons/social-5.png" />
                  {/* <p className="m-0">10:00AM to 5:00PM Eastern Time</p> */}
                  <p className="m-0">Monday - Friday: 9:00AM to 5:00PM EST</p>
                </div>
              </div>
            )}
          </div>
          </div>
          {serviceForm && (
            <div className="col-md-6 pb-md-3 my-md-auto my-5">
              {/* <form className="service-form  d-flex flex-column px-4 py-5 mx-auto" onSubmit={formSubmitHandler}>
                <h3 className="body-heading">
                  Let’s get in touch!
                </h3>
                <p
                  className="body-paragraph text-start"
                >
                  For general inquiries or to schedule a consultation, please complete the form below.
                </p>
                <input type="text" placeholder="Your Full Name" required value={name} onChange={(e)=>{setName(e.target.value)}}/>
                <input type="text" placeholder="Your Email Address" required value={email} onChange={(e)=>{setEmail(e.target.value)}}/>
                <input type="text" placeholder="Phone Number" required value={phone} onChange={handlePhoneChange}/>
                <input type="text" className="mb-3" placeholder="Your Message" required value={message} onChange={(e)=>{setMessage(e.target.value)}}/>

                 <ReCAPTCHA
                    sitekey="6LcPMZ8rAAAAAEGjoaxRfc_sd8741D5WMEVlud9f"
                    onChange={handleCaptchaChange}
                  />
                <button className="service-from-btn  blue-btn" type="submit">Submit
                   {loading ? (
                            <Spinner
                              animation="border"
                              role="status"
                              style={{ color: "white",marginLeft:"10px",width:"15px",height:"15px" }}
                            />
                      ) : (
                        success ? (
                          <div>
                            {setLoading(false)}
                              {alert(success)}
                            {setSuccess(false)}
                          </div>
                        ) : (
                          error && (
                            <div>
                              {setLoading(false)}
                              {alert(error)}
                              {setError(false)}
                            </div>
                          )
                        )
                      )}

                </button>
              </form> */}
                {/* <InlineWidget url="https://calendly.com/chandrancpa" styles={{height:"450px",margin:"0"}}/>  */}
                   <CalendlyWidget/>
              
            </div>
          )}
        </div>
      </div>
      <div className="w-100">
      {
        showPartners &&
        <Swiper
            loop={true}
            autoplay={{
              delay: 1800,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            breakpoints={{
              1200: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 25,
              },
              778: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              480: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
            }}
          >
                  <SwiperSlide  className="swiperSlide">
                    <img  loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-1.png"} alt="partner company logo" style={{height:"100%"}} />
                  </SwiperSlide>
                  <SwiperSlide  className="swiperSlide">
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-2.png"} alt="partner company logo" style={{maxWidth:"120px"}} />
                  </SwiperSlide>
                  <SwiperSlide  className="swiperSlide">
                    {/* <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-3.png"} alt="partner company logo" style={{maxWidth:"200px"}} /> */}
                    <img loading="lazy" className="img-fluid " src={"/images/icons/cpao-logo.svg"} alt="partner company logo" style={{maxWidth:"160px"}} />
                  </SwiperSlide>
                  <SwiperSlide  className="swiperSlide">
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-4.png"} alt="partner company logo" style={{maxWidth:"160px"}} />
                  </SwiperSlide>
                  <SwiperSlide  className="swiperSlide">
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-5.png"} alt="partner company logo" style={{height:"100%"}} />
                  </SwiperSlide>
                  <SwiperSlide className="swiperSlide">
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-6.png"} alt="partner company logo" style={{width:"140px"}} />
                  </SwiperSlide>
                  <SwiperSlide className="swiperSlide">
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-7.png"} alt="partner company logo" style={{height:"100%"}} />
                  </SwiperSlide>
                  <SwiperSlide className="swiperSlide">
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-8.png"} alt="partner company logo" style={{width:"180px"}} />
                  </SwiperSlide>
           
          </Swiper>
      }
      </div>
    </div>
  );
};

export default HeroBanner; 

const CalendlyWidget = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className="calendly-inline-widget"
      data-url="https://calendly.com/chandrancpa/30min"
      style={{ minWidth: "320px", height: "600px"}}
    ></div>
  );
};